export default "__VITE_ASSET__BPn4yB9j__"